export default __webpack_public_path__ + "static/qualys-p4i-f03c10626403aa6633a993acc7a56055.webp";